const privateStyles = () => ({
  position: 'relative',
  marginTop: '10px',

  '&.dn-hidden': {
    display: 'none !important',
  },

  '&.dn-hide-label': {
    marginTop: '0',
    '.MuiInputLabel-root': {
      display: 'none',
    },
    '.MuiOutlinedInput-notchedOutline': {
      'legend > span': {
        display: 'none',
      },
    },
  },

  '&.dn-open': {
    '.MuiIconButton-root.dn-button-small': {
      transform: 'rotate(180deg)',
    },
  },

  '.MuiOutlinedInput-root': {
    padding: '0',
    '.MuiOutlinedInput-input': {
      padding: '9.5px 14px !important',
    },

    '.MuiInputAdornment-root': {
      marginLeft: '0',
      width: '45px',
      '&.MuiInputAdornment-positionEnd': {
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        right: '0',
        zIndex: '100',
      },
      '.MuiIconButton-root.dn-button-small': {
        padding: '2px',
        transition: 'all 0.2s ease 0s',
        '.MuiSvgIcon-root': {
          fill: '#2845D2 !important',
          width: '18px',
          height: '18px',
        },
      },
    },

    fieldset: {
      border: '1px solid rgba(229, 229, 229, 1) !important',
      borderRadius: '5px !important',

      '&:hover': {
        border: '1px solid rgba(40, 69, 210, 0.5) !important',
      },

      'legend > span': {
        display: 'flex',
        alignItems: 'center',
        '.dn-help-wrapper': {
          '.MuiSvgIcon-root': {
            width: '15px',
            height: '15px',
          },
        },
      },
    },

    'input, textarea': {
      color: '#6A6A6A !important',
      fontSize: '14px !important',
      height: '23px',
    },

    '&.Mui-focused': {
      fieldset: {
        border: '2px solid rgba(40, 69, 210, 0.3) !important',
      },
    },

    '&.Mui-disabled': {
      fieldset: {
        background: '#F4F4F4',
      },

      input: {
        zIndex: '99',
      },
    },

    '&.Mui-error': {
      fieldset: {
        background: 'rgba(255, 0, 0, 0.04)',
      },
    },
  },

  '.MuiInputLabel-root': {
    fontSize: '16px',
    color: '#6A6A6A',
    display: 'flex',
    alignItems: 'center',
  },

  '.MuiSvgIcon-root': {
    fill: '#B2B2B2 !important',
    width: '15px',
    height: '15px',
  },

  'textarea.MuiOutlinedInput-input': {
    padding: '0 !important',
  },

  '.dn-clipboard': {
    position: 'absolute',
    right: '0',
    bottom: '0',
    zIndex: '99',

    '.dn-button-clipboard': {
      fontSize: '12px !important',
      minHeight: '42px !important',
      lineHeight: '42px !important',
      textTransform: 'none !important',
      boxShadow: 'none !important',
      color: '#2845D2 !important',
      background: 'transparent !important',
      padding: '0 !important',
      width: '42px !important',
      minWidth: '42px !important',
      fontWeight: 'bold',
      borderRadius: '5px !important',

      '&:hover': {
        background: 'rgba(29, 50, 153, 0.08) !important',
      },
    },
  },
  '&.dn-clipboard': {
    '.Mui-disabled': {
      input: {
        color: '#7B7B7B',
        fontFamily: 'Inter',
        paddingRight: '42px !important',
      },
    },
  },
  '.dn-help-wrapper': {
    '.MuiSvgIcon-root': {
      width: '20px',
      height: '20px',
      marginLeft: '2px',
    },
    '.MuiTouchRipple-root': {
      transform: 'translate(5px, 3px)',
      overflow: 'visible',
      top: '-2px',
      right: '-2px',
      bottom: '-2px',
      left: '-2px',
    },
  },
  '.MuiInputBase-multiline.MuiInputBase-multiline': {
    textarea: {
      padding: '0 !important',
      margin: '9.5px 14px !important',
    },
  },
  '[type="search"]::-webkit-search-cancel-button, [type="search"]::-webkit-search-decoration': {
    WebkitAppearance: 'none',
    appearance: 'none',
  },
});

export default privateStyles;
